import { useIntl } from 'react-intl';

import { ROUTES } from '@xing-com/crate-jobs-paths';
import { ActionSlot } from '@xing-com/crate-layout-top-bar';
import { IconBookmark } from '@xing-com/icons';

const MyJobsSlot: React.FC = () => {
  const { formatMessage } = useIntl();

  const label = formatMessage({ id: 'VERTICAL_NAV_YOUR_JOBS_LABEL' });

  return (
    <ActionSlot
      size="small"
      showLabel
      text={label}
      icon={IconBookmark}
      to={ROUTES.myJobs}
      aria-label={label}
    />
  );
};

export const getPrimaryActions = (): React.ReactElement[] => {
  return [<MyJobsSlot key="1" />];
};
